import React, { useState } from 'react'
import {
  List,
  Filter,
  useListRepository,
  useFilter,
  TextField,
  Select
} from 'elentari'
import { Field } from 'react-final-form'
import Grid from '@material-ui/core/Grid'
import { withStyles, Fab, Tooltip, CircularProgress } from '@material-ui/core'
import Sync from '@material-ui/icons/Sync'
import centrosCustoRepository from './CentrosCustoRepository'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import { useHistory } from 'react-router-dom'
import UsuarioAutocomplete from '../Usuarios/UsuarioAutocomplete'
import EmpresaSelect from '../Empresa/EmpresaSelect'
import UnidadeNegocioAutocomplete from '../UnidadeNegocio/UnidadeNegocioAutocomplete'

const styles = theme => ({
  fab: {
    position: 'fixed',
    right: theme.spacing(4),
    bottom: theme.spacing(12)
  }
})

const CentroCustoFilter = () => {
  const filter = useFilter({})

  return (
    <Filter {...filter} labels={{ find: 'Buscar', clear: 'Limpar' }}>
      <Grid container spacing={3}>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            name="descricao"
            label="Descrição"
            component={TextField}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            name="gestorId"
            label="Gestor"
            realm="gestor"
            component={UsuarioAutocomplete}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <EmpresaSelect />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="unidadeNegocioId"
            label="Unidade de Negocio"
            component={UnidadeNegocioAutocomplete}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            hideEmpty
            component={Select}
            options={[
              { label: 'Ativo', value: true },
              { label: 'Inativo', value: false }
            ]}
            label="Status"
            name="ativo"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const CentrosCusto = ({ classes, ...props }) => {
  const [fetching, setFetching] = useState()
  const history = useHistory()

  const [ability] = useAbility()
  const listOptions = {
    defaultOrder: 'id',
    fields: {
      id: {
        label: 'Id'
      },
      descricao: {
        label: 'Descrição'
      },
      gestores: {
        label: 'Gestores',
        format: gestores => gestores.map(gestor => gestor.usuario).join(', '),
        noOrder: true
      },
      empresa: {
        label: 'Empresa',
        format: empresa => (empresa ? empresa.nome : '')
      },
      unidadeNegocio: {
        label: 'Unidade de Negócio',
        format: unidadeNegocio =>
          unidadeNegocio ? unidadeNegocio.descricao : ''
      },
      ativo: {
        label: 'Status',
        format: value => (value ? 'Ativo' : 'Inativo')
      }
    }
  }

  const listHook = useListRepository({
    repository: centrosCustoRepository,
    path: 'centrosCusto'
  })
  const actions = getListActions(ability, listHook, 'centrosCusto')

  const handleSync = async () => {
    setFetching(true)
    await centrosCustoRepository.sync()
    await listHook.fetchList()
    setFetching(false)
  }

  const handleClickEdit = item =>
    history.push(`/centrosCusto/${item.id}${history.location.search}`)

  return (
    <>
      <CentroCustoFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickEdit={handleClickEdit}
        onClickView={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
      <Tooltip title="Sincronizar">
        <Fab
          aria-label="Sincronizar"
          className={classes.fab}
          color="secondary"
          onClick={handleSync}
        >
          {fetching ? <CircularProgress size={24} color="inherit" /> : <Sync />}
        </Fab>
      </Tooltip>
    </>
  )
}

export default withStyles(styles)(CentrosCusto)
